import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { TEntityGridConstraints } from 'app/common/entity-grid/core';
import * as EntityGrid from 'app/common/entity-grid/features';
import { HotFixEntityGridReadRequest } from 'app/common/entity-grid/features/entity-grid';
import { useUserRoles } from 'app/railways/domains/access/features/roles/use-user-roles';

import { getRolesRequest } from '../../../requests';
import { cols } from './roles-columns';

export const RolesEntityGrid = observer(() => {
  const userRoles = useUserRoles();

  const initialConstraints = useMemo<TEntityGridConstraints>(
    () => ({
      sorting: [{ name: 'id', direction: 'descend' }],
    }),
    [],
  );

  return (
    <EntityGrid.Root
      columns={cols}
      rowModelType="largeList"
      recordsLimit={1000}
      initialState={initialConstraints}
      request={getRolesRequest}
      userRoles={userRoles}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          padding: 16,
          height: '100%',
        }}
      >
        <EntityGrid.NotificationsRender>
          {(notifications) => <div>{notifications}</div>}
        </EntityGrid.NotificationsRender>

        <HotFixEntityGridReadRequest />

        <div style={{ flexGrow: 1 }}>
          <EntityGrid.Table
            mapResourceContent={(data) =>
              'content' in data ? data?.content : data
            }
            rowSelection="multiple"
            persistSettingsId="RoutesEntityGrid"
          />
        </div>
      </div>
    </EntityGrid.Root>
  );
});
